module.exports = __webpack_public_path__ + "img/namshi.d52decf3.svg";